/**
 * Mapa de redirects 301 (equivalente ao `redirects()` do Next.js).
 * Chave = caminho de origem normalizado (sem barra final, minúsculo).
 * Valor = caminho de destino canônico.
 */
// Fonte única: tabela public.redirects (sincronizada a cada publicação por scripts/sync-redirects.ts).
// Backup da lista anterior: docs/backup-redirects/.
import REDIRECTS_DATA from "./redirects.data.json";
export const REDIRECTS: Record<string, string> = REDIRECTS_DATA as Record<string, string>;

export function normalizePathname(pathname: string): string {
  let raw = pathname || "/";
  try { raw = decodeURIComponent(raw); } catch { /* mantém */ }
  let p = raw.toLowerCase();
  if (p.length > 1) p = p.replace(/\/+$/, "");
  return p || "/";
}

/**
 * Retorna o destino canônico final para um caminho (seguindo cadeias de
 * redirect, ex.: /incoterms → /artigo/incoterms → /artigo/incoterms-o-que-…),
 * ou null se não houver redirect.
 */
export function resolveRedirect(pathname: string): string | null {
  const start = normalizePathname(pathname);
  let current = start;
  const seen = new Set<string>([current]);
  for (let i = 0; i < 10; i++) {
    const next = REDIRECTS[current];
    if (!next) break;
    const norm = normalizePathname(next);
    if (seen.has(norm)) break;
    seen.add(norm);
    current = norm;
  }
  if (current !== start) return current;
  // Letras maiúsculas / codificação: redireciona para a forma minúscula canônica.
  let raw = pathname;
  try { raw = decodeURIComponent(pathname); } catch { /* mantém */ }
  if (raw.replace(/\/+$/, "") !== start && start.length > 1 && /[A-Z]/.test(raw)) return start;
  return null;
}
